import { render, staticRenderFns } from "./ModalBack.vue?vue&type=template&id=9bbacbf0&scoped=true&"
import script from "./ModalBack.vue?vue&type=script&lang=js&"
export * from "./ModalBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbacbf0",
  null
  
)

export default component.exports